/**
 * @generated SignedSource<<afd94ff0396fdbbfe6c929dbb214b243>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserStatusInput = "active" | "activeEfnNeeded" | "changeInProgress" | "doccheck" | "doctorWithEfnInitialValidation" | "efnNeeded" | "inactive" | "initialValidation" | "noProcess" | "%future added value";
export type AddSpecificUserStatusesCanStartContentConfigInput = {
  clientMutationId?: string | null | undefined;
  contentNodeId: string;
  dateTime?: string | null | undefined;
  userStatuses: ReadonlyArray<UserStatusInput>;
};
export type SpecificUserStatusesCanStartContentConfigForm_AddMutation$variables = {
  input: AddSpecificUserStatusesCanStartContentConfigInput;
};
export type SpecificUserStatusesCanStartContentConfigForm_AddMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addSpecificUserStatusesCanStartContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type SpecificUserStatusesCanStartContentConfigForm_AddMutation = {
  response: SpecificUserStatusesCanStartContentConfigForm_AddMutation$data;
  variables: SpecificUserStatusesCanStartContentConfigForm_AddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpecificUserStatusesCanStartContentConfigForm_AddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddSpecificUserStatusesCanStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addSpecificUserStatusesCanStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpecificUserStatusesCanStartContentConfigForm_AddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddSpecificUserStatusesCanStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addSpecificUserStatusesCanStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isStartContentConfig"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "configType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requiredUserStatuses",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpecifiedUserStatusesCanStartContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48916e639e4fec38308d004e64eeb363",
    "id": null,
    "metadata": {},
    "name": "SpecificUserStatusesCanStartContentConfigForm_AddMutation",
    "operationKind": "mutation",
    "text": "mutation SpecificUserStatusesCanStartContentConfigForm_AddMutation(\n  $input: AddSpecificUserStatusesCanStartContentConfigInput!\n) {\n  Admin {\n    Tree {\n      addSpecificUserStatusesCanStartContentConfig(input: $input) {\n        contentNode {\n          ...SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment on StartContentConfig {\n  __isStartContentConfig: __typename\n  ... on SpecifiedUserStatusesCanStartContentConfig {\n    id\n    configType\n    dateTime\n    requiredUserStatuses\n  }\n}\n\nfragment SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      startConfigs {\n        __typename\n        ...SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "854a9904a57f0c010a6dae26d2ca5f1a";

export default node;
